

















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { EPaymentMethodType, IResidentPaymentMethod } from '@zunta/configurations'
import { Watch } from 'vue-property-decorator'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import { plus } from '@/utils/helpers'

@Component({
  components: { Checkbox },
  props: {
    amount: {
      default: 0
    },
    showAnyway: {
      type: Boolean,
      default: false
    },
    selectedCard: {
      default: 0
    },
    checked: {
      type: Boolean,
      default: false
    },
    eCheckChecked: {
      type: Boolean,
      default: false
    }
  }
})
export default class PaymentSurcharge extends Vue {
  user: User = Api.getUser() as User
  includeSurcharge: boolean = false
  includeECheckSurcharge: boolean = false

  get surchargeAmount () {
    if (this.methodInCCPayment) {
      return +this.$props.amount * 0.0295
    }

    if (this.methodInECheckPayment) {
      return +this.$props.amount > 10000
          ? plus(+this.$props.amount * 0.005, 0)
          : 0
    }

    return 0
  }

  get totalWithSurchargeAmount () {
    this.$emit('changeSurchargeAmount', this.surchargeAmount)
    return plus(+this.$props.amount, this.surchargeAmount)
  }

  get paymentMethods () {
    return this.$store.state.resident.paymentMethods
  }

  get ccPaymentMethods () {
    return this.paymentMethods.filter((paymentMethod: IResidentPaymentMethod) => {
      return paymentMethod.type === EPaymentMethodType.CREDIT_CARD
    })
  }

  get ECheckPaymentMethods () {
    return this.paymentMethods.filter((paymentMethod: IResidentPaymentMethod) => {
      return paymentMethod.type === EPaymentMethodType.ECHECK
    })
  }

  get methodInCCPayment () {
    if (!this.$props.selectedCard) {
      return false
    }
    if (typeof this.$props.selectedCard === 'number') {
      return this.ccPaymentMethods.some((cc: any) => Number(cc.id) === Number(this.$props.selectedCard))
    }
    return this.ccPaymentMethods.some((cc: any) => Number(cc.id) === Number(this.$props.selectedCard.id))
  }

  get methodInECheckPayment () {
    if (!this.$props.selectedCard) {
      return false
    }
    if (typeof this.$props.selectedCard === 'number') {
      return this.ECheckPaymentMethods.some((cc: any) => Number(cc.id) === Number(this.$props.selectedCard))
    }
    return this.ECheckPaymentMethods.some((cc: any) => Number(cc.id) === Number(this.$props.selectedCard.id))
  }

  get residentFacility () {
    return this.$store.state.resident.selectedResident && this.$store.state.resident.selectedResident.facility
  }

  get selectedFacilityAllowSurcharge () {
    return !!(this.residentFacility && this.residentFacility.allowSurcharge)
  }

  get selectedFacilityAllowECheckSurcharge () {
    return !!(this.residentFacility && this.residentFacility.allowECheckSurcharge)
  }

  toggleSurcharge (value: boolean) {
    this.includeSurcharge = value
    this.$emit('setSurcharge', value)
  }

  toggleECheckSurcharge (value: boolean) {
    this.includeECheckSurcharge = value
    this.$emit('setECheckSurcharge', value)
  }

  watchSurchargeHandler () {
    if (this.user.isResident() && this.paymentMethods.length) {
      if (this.methodInCCPayment) {
        this.toggleECheckSurcharge(false)
        this.toggleSurcharge(this.selectedFacilityAllowSurcharge)
      }
      if (this.methodInECheckPayment) {
        this.toggleECheckSurcharge(this.selectedFacilityAllowECheckSurcharge)
        this.toggleSurcharge(false)
      }
    }
  }

  @Watch('selectedCard', { deep: true, immediate: true })
  watchAllowSurcharge () {
    this.$nextTick(this.watchSurchargeHandler)
  }

  @Watch('residentFacility', { deep: true, immediate: true })
  watchFacilityAllowSurcharge () {
    this.$nextTick(this.watchSurchargeHandler)
  }
}
